import { AccountState } from './types';

export const isLoggedIn = (state: AccountState) => Boolean(state.token);

export const userInfo = (state: AccountState) => {
  return {
    email: state.userName,
    company: state.company,
    subscription: state.Subscription,
    firstName: state.firstName,
    lastName: state.lastName,
    newsLetter: state.newsLetter,
    permissions: state.permissions,
  };
};

export const subscriptionInfo = (state: AccountState) => {
  return {
    subscription: state.Subscription,
    company: state.company,
    kvkNr: state.kvkNr,
    ibanName: state.ibanName,
    ibanNr: state.ibanNr,
    incassoAccepted: state.incassoAccepted,
    daysTillEnd: state.daysTillEnd,
    inlenerWebModule: state.inlenerWebModule,
    caosAgreement: state.caosAgreement,
    caosTool: state.caosTool,
  };
};

export const pdfAllowed = (state: AccountState) => {
  return Boolean(state.token) && (state.Subscription === 'monthly_big' ||
    state.Subscription === 'monthly_middle' ||
    state.Subscription === 'trial');
};

export const trialEnded = (state: AccountState) => {
  return !(state.daysTillEnd > 0 && state.daysTillEnd !== -1) && state.Subscription === 'trial';
};

export const trialDue = (state: AccountState) => {
  const due =
  (state.Subscription === 'trial' &&
  state.daysTillEnd > 0 && state.daysTillEnd < 8) ? state.daysTillEnd : false;
  return due;
};
